import { InitState } from '../../../../../redux/reducers/root/initialState'
import {
  manuallyEditDescription,
  manuallyEditLocation,
  manuallyEditTitle,
} from '../../../../../redux/reducers/suggestedText/suggestedTextFeature'
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks'
import { logAiTextInvestigation } from '../../../../../redux/thunks/suggestedText/suggestedTextLogging'

export const useSuggestion = (enabledHook: boolean) => {
  const dispatch = useAppDispatch()
  const {
    isLocationManuallyEdited,
    isDescriptionManuallyEdited,
    isTitleManuallyEdited,
    suggestedTitle,
    suggestedDescription,
    suggestedLocation,
  } = useAppSelector((state: InitState) => state.suggestedTextFeature)
  const showTitleSubtitle = !isTitleManuallyEdited && enabledHook && (suggestedTitle ?? '').length > 0
  const showDescriptionSubtitle = !isDescriptionManuallyEdited && enabledHook && (suggestedDescription ?? '').length > 0
  const showLocationSubtitle = !isLocationManuallyEdited && enabledHook && (suggestedLocation ?? '').length > 0

  const onHandleTitleChange = () => {
    if (!enabledHook || isTitleManuallyEdited) {
      return false
    }

    logAiTextInvestigation('manual_edit_detected', { field: 'adTitle', hadSuggestion: Boolean(suggestedTitle) })
    return dispatch(manuallyEditTitle())
  }
  const onHandleDescriptionChange = () => {
    if (!enabledHook || isDescriptionManuallyEdited) {
      return false
    }

    logAiTextInvestigation('manual_edit_detected', {
      field: 'adDescription',
      hadSuggestion: Boolean(suggestedDescription),
    })
    return dispatch(manuallyEditDescription())
  }
  const onHandleLocationChange = () => {
    if (!enabledHook || isLocationManuallyEdited) {
      return false
    }

    logAiTextInvestigation('manual_edit_detected', { field: 'adLocation', hadSuggestion: Boolean(suggestedLocation) })
    return dispatch(manuallyEditLocation())
  }

  return {
    showTitleSubtitle,
    showDescriptionSubtitle,
    showLocationSubtitle,
    onHandleTitleChange,
    onHandleDescriptionChange,
    onHandleLocationChange,
  }
}
